import {
  boolean,
  pgTable,
  serial,
  timestamp,
  varchar,
} from "drizzle-orm/pg-core"
import USER_TYPE from "$types/USER_TYPE"
import { relations } from "drizzle-orm"
import { integer } from "drizzle-orm/pg-core"
import { organizationsTable } from "./Organizations"
import USER_IN_ORGANIZATION_ROLES from "$types/USER_IN_ORGANIZATION_ROLES"

export const usersTable = pgTable("Users", {
  id: serial().primaryKey(),
  creationTimestamp: timestamp({ withTimezone: true }).defaultNow(),
  lastInteractionTimestamp: timestamp({ withTimezone: true }).defaultNow(),
  type: varchar({ length: 255 }).notNull().$type<USER_TYPE>(),
  firstName: varchar({ length: 255 }).notNull().default(""),
  lastName: varchar({ length: 255 }).notNull().default(""),
  email: varchar({ length: 255 }).notNull(), // todo: not null / unique - handle anonymous users
  privacyPolicyAcceptance: boolean().notNull(),
  termsConditionsAcceptance: boolean().notNull(),
  isAnonymous: boolean().notNull().default(false),
  accountCompleted: boolean().notNull().default(false),
  organizationId: integer().references(() => organizationsTable.id),
  role: varchar({ length: 255 }).$type<USER_IN_ORGANIZATION_ROLES>(),
  blocked: boolean().notNull().default(false),
  password: varchar({ length: 255 }),
})

export const usersRelations = relations(
  usersTable,
  ({ one }) => ({
    organization: one(organizationsTable, {
      fields: [usersTable.organizationId],
      references: [organizationsTable.id]
    })
  }),
)

export type UserSchema = typeof usersTable.$inferSelect
export type NewUserSchema = typeof usersTable.$inferInsert
